// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/is-callable.js